<ng-container [formGroup]="form">
  <div class="form-grid">
    <div class="d-flex flex-column gap-2">
      <label [for]="'primaryPhoneNumber'" class="form-input-label" i18n>Primary Phone Number</label>
      <app-phone-country-code
        controlId="primaryPhoneNumber"
        phoneNumberControlName="primaryPhoneNumber"
        countryCodeControlName="primaryPhoneNumberCountryCode"
        [countryCodes]="countryCodes$ | async"
        [formGroup]="form"
        [error]="formSubmitted && form.controls.primaryPhoneNumber.invalid" />
      <app-form-error
        *ngIf="formSubmitted && form.controls.primaryPhoneNumber.invalid"
        [errors]="form.controls.primaryPhoneNumber.errors"
        [customErrorMessages]="customErrorMessages.primaryPhoneNumber" />
    </div>
    <div class="d-flex flex-column gap-2">
      <label [for]="'secondaryPhoneNumber'" class="form-input-label" i18n>Secondary Phone Number</label>
      <app-phone-country-code
        controlId="secondaryPhoneNumber"
        phoneNumberControlName="secondaryPhoneNumber"
        countryCodeControlName="secondaryPhoneNumberCountryCode"
        [countryCodes]="countryCodes$ | async"
        [formGroup]="form"
        [error]="formSubmitted && form.controls.secondaryPhoneNumber.invalid" />
      <div class="form-input-hint" i18n>Optional</div>
      <app-form-error
        *ngIf="formSubmitted && form.controls.secondaryPhoneNumber.invalid"
        [errors]="form.controls.secondaryPhoneNumber.errors" />
    </div>
  </div>

  <hr class="address-divider" />

  <app-international-address-form-grid
    controlIdPrefix="memberOnboardingAddress"
    [form]="form.controls.address"
    [formSubmitted]="formSubmitted" />
</ng-container>
